import useMutation from "src/hooks/useMutation";

function useWTProdRemove(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/transferDetailId`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useWTProdRemove;
